export const theme = {
    colors: {
        dark: 'rgb(19, 21, 32)',
        mid_dark: 'rgb(22, 34, 36)',
        light: 'rgb(29, 33, 46)',
        emphasis: 'rgb(255,255, 255)',
        main_font: 'rgb(255, 255, 255)',
        secondary_font: 'rgba(255, 255, 255, 0.71)',
        box: 'linear-gradient(rgb(48, 50, 62), rgb(30, 31, 42))'
    },
    spacing: {
        horizontal_default: 25,
        vertical_default: 15
    },
    fonts_size: {
        label: 15,
        span: 16,
        title: 28,
        subtitle: 14
    }
}